// @ts-check
import { useState } from "react"
import { getIndividualTasksOfClientIdLazy } from "../../services/report.service"
import {
  buildHeadersForCSV,
  convertToCSV,
  downloadCSV,
  getExportFilename,
  makeTasksPerClientBaseFilename,
  normalizeTasksForCSV,
} from "../../utils/report.utils"

export function useExportTasksPerClient() {
  /** @type {[boolean, Function]} */
  const [loading, setLoading] = useState(false)

  /**
   * @param {{
   *  clientCode: string,
   *  filterConfig: any,
   *  sortConfig: any,
   *  startDate: any,
   *  endDate: any,
   *  period: string,
   *  isLink?: boolean
   * }} params
   */
  const exportTasks = async (params) => {
    setLoading(true)

    const response = await getIndividualTasksOfClientIdLazy(
      params.clientCode,
      params.filterConfig,
      params.sortConfig,
      params.startDate,
      params.endDate,
      0,
      Number.MAX_SAFE_INTEGER
    )

    if (!response.success || !response.result?.tasks) {
      setLoading(false)
      return { success: false, message: response?.message }
    }

    const normalizedTasks = normalizeTasksForCSV(response.result.tasks)
    const headers = buildHeadersForCSV(normalizedTasks)
    const tasksCSV = convertToCSV(normalizedTasks, headers)

    downloadCSV(
      tasksCSV,
      getExportFilename(
        makeTasksPerClientBaseFilename(params.clientCode),
        [params.startDate, params.endDate],
        params.period
      )
    )

    setLoading(false)
    return { success: true }
  }

  return {
    exportTasks,
    loading,
  }
}
